export enum QueryType {
  Selector = 'selector',
  Regex = 'regex',
  JSON = 'json',
  Contains = 'contains',
  Parent = 'parent',
}
